import { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import AdminLogin from "../components/admin/AdminLogin";
import AnalyticsDashboard from "../components/admin/AnalyticsDashboard";

const API = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "pb_admin_token";

export default function Admin() {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY) || "");

  // Validate any stored token on mount; drop it if expired/invalid.
  useEffect(() => {
    const stored = localStorage.getItem(TOKEN_KEY);
    if (!stored) return;
    fetch(`${API}/api/admin/verify`, { headers: { Authorization: `Bearer ${stored}` } })
      .then((r) => {
        if (!r.ok) {
          localStorage.removeItem(TOKEN_KEY);
          setToken("");
        }
      })
      .catch(() => {});
  }, []);

  const handleSuccess = (t) => {
    localStorage.setItem(TOKEN_KEY, t);
    setToken(t);
  };

  const handleLogout = () => {
    localStorage.removeItem(TOKEN_KEY);
    setToken("");
  };

  return (
    <>
      <Helmet>
        <title>Analytics Console · Dr. P. B. Boss</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      {token ? (
        <AnalyticsDashboard token={token} onLogout={handleLogout} onAuthError={handleLogout} />
      ) : (
        <AdminLogin onSuccess={handleSuccess} />
      )}
    </>
  );
}
